import React from "react"
import { SERVICE_LABEL } from "../../utils/variables/common"

const AmenityRow = ({ services }) => {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      {services.map((s) => {
        const Icon = SERVICE_LABEL[s] || Waves
        return (
          <span
            key={s}
            className="inline-flex items-center gap-1.5 text-xs text-[#5A6779]"
            title={SERVICE_LABEL[s] || s}
          >
            <Icon size={14} strokeWidth={2} />
            {SERVICE_LABEL[s] || s}
          </span>
        )
      })}
    </div>
  )
}

export default AmenityRow
